/**
 * Login selectors
 */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Container state
 */
const selectLoginState = state => state.login || initialState;

/**
 *  Fetch state
 */
const selectStatus = () =>
  createSelector(selectLoginState, localstate => ({
    status: localstate.status,
    statusDetails: localstate.statusDetails,
  }));

const selectVerifying = () =>
  createSelector(
    selectLoginState,
    state => state.verifying
  );

const selectPassThroughToken = () =>
  createSelector(
    selectLoginState,
    state => state.passThroughToken
);

const selectUsername = () =>
  createSelector(
    selectLoginState,
    state => state.username
);

export { selectLoginState, selectStatus, selectVerifying, selectPassThroughToken, selectUsername };
